<i18n
  src="@/locales/views/agro_exporter/production/basic_container_quality/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_final_quality.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i><span class="space-icon"></span
      >{{ $t("labels.containers_title") }}
    </h1>
    <div class="flex flex-row justify-between">
      <div class="panel-plain-label">
        <badge-default
          :label="
            containers.length + ' ' + $t('labels.total_number_containers')
          "
        />
        <span class="space-actions" />
        <container-final-quality-status
          :status_id="0"
          :prepend_label="numContainersRejected"
        />
        <span class="space-actions" />
        <container-final-quality-status
          :status_id="1"
          :prepend_label="numContainersMediumQuality"
        />
        <span class="space-actions" />
        <container-final-quality-status
          :status_id="2"
          :prepend_label="numContainersHighQuality"
        />
      </div>
      <button type="button" @click.prevent="downloadReport" class="btn-white">
        <i
          :class="[
            'fa-solid',
            downloading ? 'fa-sync fa-spin' : 'fa-file-excel'
          ]"
        ></i>
        <span class="space-icon"></span>{{ $t("labels.download_button") }}
      </button>
    </div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.container_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container_final_quality.status") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.provider") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.packing_house") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.load_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.customer") }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">{{ container.week }}</td>
                  <td
                    class="table-cell-main link"
                    @click.prevent="goToShowContainer(container.id)"
                  >
                    {{ container.container_code }}
                  </td>
                  <td class="table-cell">
                    <container-final-quality-status
                      :status_id="container.container_final_quality?.status_id"
                    />
                  </td>
                  <td class="table-cell">
                    {{ container.provider_name }}
                    <div>
                      {{ container.extra_providers.join(", ") }}
                    </div>
                  </td>
                  <td class="table-cell">
                    {{ container.packing_house?.name }}
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(container.load_date) }}
                  </td>
                  <td class="table-cell">
                    {{ container.customer?.name }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/basic_container_quality/show_process.js";
import ContainerFinalQualityStatus from "@/components/views/agro_exporter/production/shared/container/ContainerFinalQualityStatus.vue";

export default {
  name: "AEProductionBasicContainerExportShowProcessContainers",
  components: { ContainerFinalQualityStatus },
  data() {
    return {
      downloading: false
    };
  },
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    agro_exporter_process: { required: true },
    containers: {
      type: Array,
      required: true
    }
  },
  computed: {
    numContainersRejected: function () {
      return this.containers.filter(
        container => container.container_final_quality?.status_id == 0
      ).length;
    },
    numContainersMediumQuality: function () {
      return this.containers.filter(
        container => container.container_final_quality?.status_id == 1
      ).length;
    },
    numContainersHighQuality: function () {
      return this.containers.filter(
        container => container.container_final_quality?.status_id == 2
      ).length;
    }
  },
  methods: {
    downloadReport: async function () {
      this.downloading = true;
      try {
        let response = await Requester.downloadReport(
          this.agro_exporter_id,
          this.agro_exporter_process_id
        );

        const file = response.data;
        this.downloadFile(
          file,
          `Reporte-Calidad-${this.agro_exporter_process.name}.xlsx`
        );
      } catch (error) {
        error;
      }
      this.downloading = false;
    },
    goToShowContainer: function (container_id) {
      this.$router.push({
        name: this.routeName("show_container"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container_id
        }
      });
    }
  },
  watch: {}
};
</script>
